import React, { useEffect, useState } from 'react'
import { Container, ToastContext } from '@pmi/pmi-iqos-ds-react'
import {
  cookie,
  parseTranslations,
  PublishedComponent,
  CommonTranslations,
  setTranslations,
  ProfileNoDevice,
  ProfileTierCard,
  Routes,
  goTo,
  mapProfileInfo
} from '@pmi/pmi-iqos-shared-react'
import {
  getInitialPropsMock,
  buildProfileInfoData,
  buildTiersStaticInfo
} from '@iqosphere-common/utils'
import ProfileMembershipCardTranslations from './profile-membership-card.json'
import { IqosphereApiManager } from '@iqosphere-common/services'

const ProfileMembershipCardComponent = ({
  translations,
  size,
  tiers,
  line
}) => {
  const api = new IqosphereApiManager(line)

  const [profileInfo, setProfileInfo] = useState(null)
  const [profileName, setProfileName] = useState(null)
  const [tierStaticInfo, setTierStaticInfo] = useState(null)
  const [tierStatus, setTierStatus] = useState(null)
  const tokenInfo = cookie.getTokenInfo()

  if (translations) {
    setTranslations(translations)
  }

  useEffect(() => {
    async function fetchData() {
      const { membership } = await api.profile.getProfile()
      const status = membership && membership.status
      const tiersStaticInfo = buildTiersStaticInfo(tiers)
      setTierStatus(status)
      setTierStaticInfo(
        tiersStaticInfo &&
          status &&
          tiersStaticInfo.filter(tier => tier.type === status)[0]
      )
    }
    fetchData()
    const loyaltyCookieContent = cookie.getLoyaltyProfile()
    const p = loyaltyCookieContent && loyaltyCookieContent.p
    const profileInfoData = buildProfileInfoData(p)
    setProfileInfo(profileInfoData)
  }, [])

  useEffect(() => {
    async function fetchData() {
      const profileInfoRes = await api.profile.getProfileInfo()
      const profileInfo = mapProfileInfo(profileInfoRes)
      const profileName = profileInfo.lastName + ' ' + profileInfo.firstName
      setProfileName(profileName)
    }
    fetchData()
  }, [])

  return !(profileInfo && profileInfo.hasDevicesRegistered) ? (
    <Container pt="64">
      <ProfileNoDevice
        translations={translations}
        onAddDeviceClickHandler={() => {
          goTo(Routes.profileDevices, true)
        }}
      />
    </Container>
  ) : (
    tierStaticInfo && (
      <ProfileTierCard
        translations={translations}
        tierStatus={tierStatus}
        tier={tierStaticInfo}
        fullName={profileName}
        date={profileInfo && profileInfo.tierExpirationDate}
        size={size}
        showLink={false}
        isAV={!!tokenInfo.isAV}
      />
    )
  )
}

const ProfileMembershipCard = props => {
  return (
    <ToastContext>
      <PublishedComponent
        innerComponent={ProfileMembershipCardComponent}
        fullWidth
        {...ComponentDefaultProps}
        {...props}
      />
    </ToastContext>
  )
}

const ComponentTranslations = {
  ...ProfileMembershipCardTranslations,
  ...CommonTranslations
}

const ComponentDefaultProps = {
  componentName: 'ProfileMembershipCard',
  translations: {
    ...parseTranslations(ComponentTranslations, true)
  }
}

ProfileMembershipCard.getInitialProps = async req => {
  return PublishedComponent.getGlobalInitialProps({
    context: req && req.query && req.query.context,
    line: !!req?.query?.line,
    componentName: ComponentDefaultProps.componentName,
    defaultTranslations: ComponentDefaultProps.translations,
    translationsConfig: ComponentTranslations,
    getSpecificInitialProps: async () => {
      const tiers =
        req && req.query && req.query.mock === 'true'
          ? getInitialPropsMock('profileTiersStaticInfo')
          : (req.body.extra && req.body.extra.tiers) || null
      const size = (req.body.extra && req.body.extra.membershipCardSize) || null
      return {
        size,
        tiers
      }
    }
  })
}

export default ProfileMembershipCard
